
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import type { TableBodyProps } from '../../TableBody';
import TableCell from './table-row-components/table-cell/TableCell';

export type TableRowProps<Row> = Pick<TableBodyProps<Row>, 'rowClassName' | 'columns' | 'cellClassName' | 'onRowClick'> & { rowIndex: number, row: Row };

export default function TableRow<Row>({ row, columns, rowClassName, cellClassName, rowIndex, onRowClick }: TableRowProps<Row>) {
  const externalClassName = typeof rowClassName === 'function' ? rowClassName(row, rowIndex) : rowClassName;
  const className = twMerge('group/row', externalClassName);
  
  const onClick = onRowClick ? () => onRowClick(row) : undefined;

  return (
    <tr
      className={cn(
        className,
        !!onRowClick && 'cursor-pointer hover:bg-gray-100',
      )}
      onClick={onClick}
    >
      {
    columns.map((column, columnIndex) => (
      <TableCell 
        key={column.header ?? columnIndex}
        {...{ column, row, cellClassName, rowIndex }}
      />
    ))}
    </tr>
  );
}